const firmwareList = () => import('@/pages/firmware/index.vue');
const firmwareForm = () => import('@/pages/firmware/form.vue');

export default [{
    path: '/firmware',
    component: firmwareList,
    meta: [{
        name: '固件升级'
    },
    {
        name: '固件版本管理',
        activeRoute: '/firmware'
    }]
}, {
    path: '/firmware/form',
    component: firmwareForm,
    meta: [{
        name: '固件升级'
    },
    {
        name: '固件版本管理',
        url: '/firmware'
    },
    {
        name: '新增/编辑',
        activeRoute: '/firmware'
    }]
}];